import React, { Fragment } from "react";
import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";
import Reflection from "../../components/Reflection/Reflection";

export default function MyCurriculumUpload() {
  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="app-main__inner Student-page">
            <Reflection />
          </div>
        </div>
      </div>
    </Fragment>
  );
}
